import React, {
  useRef, useState, useId, useEffect,
} from 'react';
import PropTypes from 'prop-types';
import DatePicker, { CalendarContainer } from 'react-datepicker';
import moment from 'moment';
import '../DOBPicker/dobPicker.scss';
import { IMask, IMaskInput } from 'react-imask';
import { ReactComponent as ClearSvg } from '../../../../../assets/icons/close.svg';
import { ReactComponent as TimeSvg } from '../../../../../assets/icons/time.svg';

const inputFormat = 'hh:mm A';

const TimePicker = ({
  time, onChange, label, height, labelDefaultPosition, labelBG, error, errorClassName, placeholder, closeOnScroll,
  hideClearButton, dateFormat, wrapperClassName, timeIntervals, autoValidation,
}) => {
  const uniqId = useId();
  const fieldRef = useRef();
  const [inputValue, setInputValue] = useState(time || '');
  const [isValid, validToggle] = useState(true);
  const [isCalendarOpen, calendarToggle] = useState(false);

  useEffect(() => {
    if (time !== inputValue) {
      setInputValue(time);
    }
  }, [time, inputValue]);
  const changeValue = async (value) => {
    if (value !== inputValue) {
      setInputValue(value.toUpperCase());

      validToggle(true);
      onChange(value.toUpperCase());
    }
  };

  const onBlur = () => {
    if (inputValue.length && inputValue.length !== 8 && autoValidation) {
      validToggle(false);
    }
  };

  const clearDate = () => {
    setInputValue('');

    onChange('');
  };

  const closeOnScrolling = () => {
    if (closeOnScroll) {
      calendarToggle(false);
    }
  };

  const changeDate = (currentDate) => {
    validToggle(true);

    onChange(moment(currentDate).format(dateFormat));

    setInputValue(moment(currentDate).format(inputFormat));

    calendarToggle(false);
  };

  const calendarContainer = ({ className, children }) => (
    <div className="date_piker_wrapper" style={{ width: fieldRef?.current?.offsetWidth, minWidth: 130 }}>
      <CalendarContainer className={className}>
        <div style={{ position: 'relative' }}>{children}</div>
      </CalendarContainer>
    </div>
  );

  const today = moment().format('YYYY/MM/DD');

  const fullDate = time && time.length === 8
    ? new Date(moment(`${today} ${time}`).format('YYYY/MM/DD HH:mm:ss'))
    : null;

  return (
    <div
      ref={fieldRef}
      className={`calendar_wrapper single ${wrapperClassName}`}
    >
      <DatePicker
        customInput={(
          <div
            style={{ height }}
            className="dob_input_wrapper"
          >
            <div
              id={`dob-container-${uniqId}`}
              className={`dob_wrapper ${isCalendarOpen ? 'active' : ''} ${(time || placeholder || inputValue)
                ? 'with_value' : ''} ${error || !isValid ? 'error' : ''}`}
            >
              {/* <div */}
              {/*  className="dob_title" */}
              {/* > */}
              {/*  {time && moment(fullDate).format('hh:mm A')} */}

              {/*  {placeholder && !time */}
              {/*      && ( */}
              {/*      <span className="placeholder"> */}
              {/*        {moment(placeholder).isValid() */}
              {/*          ? moment(placeholder).format('hh:mm A') */}
              {/*          : placeholder} */}
              {/*      </span> */}
              {/*      )} */}
              {/* </div> */}

              <IMaskInput
                className="dob_title"
                mask="hh:mm am"
                value={inputValue}
                blocks={{
                  a: {
                    mask: IMask.MaskedEnum,
                    enum: ['A', 'P', 'a', 'p'],
                  },
                  m: {
                    mask: IMask.MaskedEnum,
                    enum: ['M', 'm'],
                  },
                  hh: {
                    mask: IMask.MaskedRange,
                    from: 1,
                    to: 12,
                  },
                  mm: {
                    mask: IMask.MaskedRange,
                    from: 0,
                    to: 59,
                  },
                }}
                unmask={false}
                placeholder={placeholder || 'hh:mm AM'}
                onAccept={(val, mask) => changeValue(mask.value)}
                onBlur={onBlur}
                onChange={() => {}}
              />

              <TimeSvg
                className="time_svg"
                onClick={() => calendarToggle((prev) => !prev)}
              />

              {label
                  && (
                    <label
                      style={{
                        '--default-position': `${labelDefaultPosition}px`,
                        '--label-bg': `${labelBG}`,
                      }}
                    >
                      {label}
                    </label>
                  )}

              {!!error && typeof error === 'string' && <p className={`error_text ${errorClassName}`}>{error}</p>}
            </div>

            {inputValue && !hideClearButton && (
              <ClearSvg
                className="clear_svg"
                onClick={clearDate}
              />
            )}
          </div>
            )}
        selected={fullDate}
        onChange={changeDate}
        strictParsing
        onClickOutside={() => calendarToggle(false)}
        showTimeSelect
        showTimeSelectOnly
        timeIntervals={timeIntervals}
        portalId={`dob-portal-${uniqId}`}
        closeOnScroll={closeOnScrolling}
        open={isCalendarOpen}
        calendarContainer={calendarContainer}
      />
    </div>
  );
};

TimePicker.propTypes = {
  time: PropTypes.string.isRequired,
  label: PropTypes.string,
  height: PropTypes.number,
  labelDefaultPosition: PropTypes.number,
  timeIntervals: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  error: PropTypes.any,
  labelBG: PropTypes.string,
  errorClassName: PropTypes.string,
  dateFormat: PropTypes.string,
  placeholder: PropTypes.string,
  wrapperClassName: PropTypes.string,
  closeOnScroll: PropTypes.bool,
  autoValidation: PropTypes.bool,
  hideClearButton: PropTypes.bool,
};

TimePicker.defaultProps = {
  error: '',
  label: '',
  labelBG: '#FFFFFF',
  height: 50,
  labelDefaultPosition: 12,
  timeIntervals: 15,
  errorClassName: '',
  placeholder: '',
  wrapperClassName: '',
  dateFormat: 'hh:mm A',
  closeOnScroll: false,
  hideClearButton: false,
  autoValidation: true,
};

export default TimePicker;
